<template>
    <div class="training-panel">
        <IconButton :on-click="showAIKnowledgeClick">
            <i class="material-icons">auto_awesome</i>
        </IconButton>
<!--        burdaki ikon butonu hiçbir aksiyon almadığı için kaldırıldı -->
<!--        <IconButton>-->
<!--            <i class="material-icons">contact_support</i>-->
<!--        </IconButton>-->
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../../../../Settings/components/IconButton.vue";
import { mapState } from "vuex";

export default Vue.extend({
    name: "TrainingPanel",
    components: { IconButton },
    props: {
        showAIKnowledge: Function,
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "openai"),
        }),
    },
    methods: {
        showAIKnowledgeClick() {
            if (this.channels.length > 0) {
                this.showAIKnowledge();
            } else {
                this.$message.error("Please add OpenAI channel first");
            }
        },
    },
});
</script>

<style scoped lang="scss">
.training-panel {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #fff;
    padding: 3px 6px;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2509803922);

    .icon-button {
        width: 30px;
        height: 30px;
        padding: 5px;
        border-radius: 5px !important;

        &:hover {
            background-color: var(--color-bg-personal-default);

            .material-icons {
                color: #fff;
            }
        }
    }
}
</style>
